import React, { Component } from 'react';
import { Modal, Form, Input, Select, Upload, Button, message, DatePicker } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import schoolmanagementapi from "../../../api/devapis/schoolmanagementapi";
import issuecategoryapi from "../../../api/devapis/issuecategoryapi";
import mastercategoryapi from "../../../api/devapis/mastercategoryapi";
import contentmanagementapi from "../../../api/devapis/contentmanagementapi";

const { TextArea } = Input;
const { Option } = Select;

class AddNewIssueModal extends Component {
  constructor(props) {
    super(props);
    props.initialconstruct && props.initialconstruct.bind(this)("AddNewIssueModal");
    this.state = {
      schoolId: undefined,
      priority: undefined,
      estimatedEndDate: null,
      raisedBy: undefined,
      assignTo: undefined,
      issueCategoryId: undefined,
      sublocation: '',
      description: '',
      fileList: [],
      attachments: [],
      categories: [],
      schools: [],
      users: [],
      loadingUsers: false,
      priorities: [],
      loadingPriorities: false,
      loadingCategories: false,
      submitting: false,
    };
  }

  componentDidMount() {
    this.fetchSchools();
    this.fetchCategories();
    this.fetchOperationsTeam();
    this.fetchPriorities();
  }

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      this.resetForm();
      this.fetchSchools();
      this.fetchCategories();
      this.fetchOperationsTeam();
      this.fetchPriorities();
    }
  }

  resetForm = () => {
    this.setState({
      schoolId: undefined,
      priority: undefined,
      estimatedEndDate: null,
      raisedBy: undefined,
      assignTo: undefined,
      issueCategoryId: undefined,
      sublocation: '',
      description: '',
      fileList: [],
      attachments: [],
    });
  };

  fetchOperationsTeam = () => {
    this.setState({ loadingUsers: true });
    const apiCall = this.props.api?.apiGetOperationTeamList || window.app?.props?.api?.apiGetOperationTeamList;
    if (!apiCall) return;

    apiCall()
      .then((res) => {
        if (res && res.data && Array.isArray(res.data)) {
          this.setState({ users: res.data, loadingUsers: false });
        } else {
          this.setState({ loadingUsers: false });
        }
      })
      .catch((err) => {
        console.error('Error fetching operations team:', err);
        this.setState({ loadingUsers: false });
      });
  };

  fetchPriorities = () => {
    this.setState({ loadingPriorities: true });
    const apiCall = this.props.api?.apiGetIssuePriorities || window.app?.props?.api?.apiGetIssuePriorities;
    if (!apiCall) return;

    apiCall()
      .then((res) => {
        if (res && res.data && Array.isArray(res.data)) {
          this.setState({ priorities: res.data, loadingPriorities: false });
        } else {
          this.setState({ loadingPriorities: false });
        }
      })
      .catch((err) => {
        console.error('Error fetching priorities:', err);
        this.setState({ loadingPriorities: false });
      });
  };

  fetchSchools = () => {
    let role = localStorage.getItem("currentAdminRole");
    if (role === "SCHOOL_COORDINATOR") return;

    const apiGetSchools = (role === "SUPER_ADMIN" || role === "OPERATION_TEAM") 
      ? (this.props.api?.apiGetAllSchoolLists || window.app?.props?.api?.apiGetAllSchoolLists)
      : (this.props.api?.apiGetAllSchoolList || window.app?.props?.api?.apiGetAllSchoolList);

    if (!apiGetSchools) return;

    apiGetSchools()
      .then(res => {
        let raw = res.data || res || [];
        if (!Array.isArray(raw)) {
          if (raw.data && Array.isArray(raw.data)) raw = raw.data;
          else if (raw.records && Array.isArray(raw.records)) raw = raw.records;
          else raw = [raw];
        }

        let schoolOptions = [];
        if (raw.length > 0 && Array.isArray(raw[0].records)) {
          schoolOptions = raw[0].records.filter(s => s && (s.school_name || s.name)).map(s => ({
            id: s.school_id || s._id || s.school_name || s.name,
            name: s.school_name || s.name
          }));
        } else {
          schoolOptions = raw.filter(s => s && (s.school_name || s.name)).map(s => ({
            id: s.school_id || s._id || s.school_name || s.name,
            name: s.school_name || s.name
          }));
        }

        this.setState({ schools: schoolOptions });
      }).catch(e => console.error("Failed to fetch schools:", e));
  };

  fetchCategories = () => {
    this.setState({ loadingCategories: true });

    const processCategories = (res) => {
      let rawList = [];
      if (res && res.data) {
        if (Array.isArray(res.data)) rawList = res.data;
        else if (Array.isArray(res.data.data)) rawList = res.data.data;
        else if (Array.isArray(res.data.records)) rawList = res.data.records;
        else if (Array.isArray(res.data.categories)) rawList = res.data.categories;
        else if (Array.isArray(res.data.issueCategories)) rawList = res.data.issueCategories;
      } else if (Array.isArray(res)) {
        rawList = res;
      } else if (res && typeof res === 'object') {
        if (Array.isArray(res.records)) rawList = res.records;
        else if (Array.isArray(res.categories)) rawList = res.categories;
        else if (Array.isArray(res.data)) rawList = res.data;
      }

      if (rawList && rawList.length > 0) {
        const formatted = rawList
          .filter((item) => item && item.isActive !== false && item.active !== false)
          .map((item, idx) => ({
            issueCategoryId: item.issueCategoryId || item._id || item.id || `cat_${idx}`,
            name: item.name || item.category_name || item.categoryName || item.title || 'Category',
          }));

        console.log('Successfully loaded categories for dropdown:', formatted);
        this.setState({ categories: formatted, loadingCategories: false });
        return true;
      }
      return false;
    };

    const apiCall = this.props.api?.apiGetIssueCategories || window.app?.props?.api?.apiGetIssueCategories;
    if (!apiCall) {
      this.setState({ loadingCategories: false });
      return;
    }

    apiCall({})
      .then((res) => {
        const success = processCategories(res);
        if (!success) this.setState({ loadingCategories: false });
      })
      .catch(() => this.setState({ loadingCategories: false }));
  };


  handleCustomRequest = ({ file, onSuccess, onError }) => {
    if (file.size > 10 * 1024 * 1024) {
      const sizeError = 'File size must be less than 10MB';
      if (window.error) window.error(sizeError);
      else message.error(sizeError);
      onError(new Error(sizeError));
      return;
    }

    const formData = new FormData();
    formData.append('file', file);
    formData.append('file_type', 'school_document');

    const uploadApi = this.props.api?.apiFileUploaderPublic || window.app?.props?.api?.apiFileUploaderPublic;
    if (!uploadApi) {
      onError(new Error('Upload API not available'));
      return;
    }

    uploadApi(formData)
      .then((res) => {
        const attachmentId =
          res?.data?.attachment_id ||
          res?.data?.data?.attachment_id ||
          res?.data?.attachmentId ||
          res?.attachment_id ||
          res?.attachmentId ||
          res?.data?._id ||
          res?.data?.id;

        if (attachmentId) {
          file.attachment_id = attachmentId;
          this.setState((prevState) => ({
            attachments: [...prevState.attachments, attachmentId],
            fileList: prevState.fileList.map((item) =>
              item.uid === file.uid
                ? { ...item, status: 'done', attachment_id: attachmentId }
                : item
            ),
          }));
          onSuccess('ok');
        } else {
          console.error('Upload succeeded but no attachment ID returned:', res);
          onError(new Error('No attachment ID returned'));
        }
      })
      .catch((err) => {
        console.error('Upload failed:', err);
        if (window.error) window.error('Failed to upload file');
        else message.error('Failed to upload file');
        onError(err);
      });
  };

  handleRemove = (file) => {
    const removeId = file.attachment_id;
    this.setState((prevState) => ({
      fileList: prevState.fileList.filter((item) => item.uid !== file.uid),
      attachments: removeId
        ? prevState.attachments.filter((id) => id !== removeId)
        : prevState.attachments,
    }));
  };

  handleUploadChange = ({ fileList }) => {
    this.setState({ fileList });
  };

  handleSubmit = () => {
    const { issueCategoryId, sublocation, description, attachments, schoolId, priority, estimatedEndDate, raisedBy, assignTo } = this.state;
    
    const role = localStorage.getItem('currentAdminRole') || window.store?.getState()?.root?.user?.role;
    const isOperation = role !== 'SCHOOL_COORDINATOR';
    const showExtraFields = role !== 'SCHOOL_COORDINATOR' && role !== 'SUPER_ADMIN';
    
    const finalSchoolId = isOperation ? schoolId : (this.props.store?.school_id || localStorage.getItem('school_id'));

    if (isOperation && !finalSchoolId) {
      if (window.error) window.error('Please select a School');
      else message.error('Please select a School');
      return;
    }

    if (!issueCategoryId) {
      if (window.error) window.error('Please select a Category');
      else message.error('Please select a Category');
      return;
    }

    const payload = {
      schoolId: finalSchoolId || '',
      issueCategoryId: issueCategoryId,
      subLocation: sublocation ? sublocation.trim() : '',
      description: description ? description.trim() : '',
      attachments: attachments || [],
    };

    if (showExtraFields) {
      if (priority) payload.issuePriorityId = priority;
      if (raisedBy) payload.raisedBy = raisedBy;
      if (assignTo) payload.assignedTo = assignTo;
    }

    this.setState({ submitting: true });
    const apiCall = this.props.api?.apiCreateIssue || window.app?.props?.api?.apiCreateIssue;
    if (!apiCall) return;

    apiCall(payload)
      .then((res) => {
        this.setState({ submitting: false });
        if (window.success) window.success('Issue created successfully');
        else message.success('Issue created successfully');
        this.resetForm();
        if (this.props.onSuccess) this.props.onSuccess(res);
        if (this.props.onCancel) this.props.onCancel();
      })
      .catch((err) => {
        this.setState({ submitting: false });
        const errMsg =
          err?.response?.data?.message ||
          err?.response?.data?.issues?.message ||
          err?.message ||
          'Failed to create issue';
        if (window.error) window.error(errMsg);
        else message.error(errMsg);
        console.error('Error creating issue:', err);
      });
  };

  render() {
    const { visible, onCancel } = this.props;
    const {
      fileList,
      categories,
      loadingCategories,
      issueCategoryId,
      sublocation,
      description,
      submitting,
      schoolId,
      priority,
      estimatedEndDate,
      raisedBy,
      assignTo,
      schools,
      users
    } = this.state;

    const role = localStorage.getItem('currentAdminRole') || window.store?.getState()?.root?.user?.role;
    const isOperation = role !== 'SCHOOL_COORDINATOR';
    const showExtraFields = role !== 'SCHOOL_COORDINATOR' && role !== 'SUPER_ADMIN';

    const defaultSchoolName =
      this.props.store?.school_name ||
      localStorage.getItem('school_name') ||
      'ABCD School';

    return (
      <Modal
        visible={visible}
        onCancel={onCancel}
        footer={null}
        width={860}
        style={{ top: '20px', paddingBottom: '20px' }}
        zIndex={1060}
        destroyOnClose={true}
        focusTriggerAfterClose={false}
        maskClosable={false}
        className="add-new-issue-modal"
        closeIcon={<i className="la la-close" style={{ fontSize: '22px', color: '#555' }}></i>}
        bodyStyle={{ padding: '32px 40px', minHeight: '620px', maxHeight: 'calc(94vh - 40px)', overflowY: 'auto' }}
      >
        <h4 className="mb-4 fw-bold" style={{ fontSize: '20px', color: '#222' }}>Add New Issue</h4>

        <Form layout="vertical" onFinish={this.handleSubmit}>
          <div className="row g-3">
            <div className="col-md-6">
              <Form.Item label={<span className="fw-bold text-secondary" style={{ fontSize: '14px' }}>School Name *</span>}>
                {isOperation ? (
                  <Select
                    placeholder="Select school name"
                    value={schoolId}
                    onChange={(val) => this.setState({ schoolId: val })}
                    style={{ width: '100%' }}
                    size="large"
                    showSearch
                    optionFilterProp="children"
                  >
                    {schools.map(s => <Option key={s.id} value={s.id}>{s.name}</Option>)}
                  </Select>
                ) : (
                  <Input
                    value={defaultSchoolName}
                    disabled
                    style={{ backgroundColor: '#e9ecef', color: '#6c757d', height: '42px', borderRadius: '6px' }}
                  />
                )}
              </Form.Item>
            </div>
            <div className="col-md-6">
              <Form.Item
                label={<span className="fw-bold text-secondary" style={{ fontSize: '14px' }}>Category *</span>}
                required
              >
                <Select
                  placeholder="Select category"
                  loading={loadingCategories}
                  value={issueCategoryId}
                  onChange={(val) => this.setState({ issueCategoryId: val })}
                  showSearch
                  allowClear
                  optionFilterProp="children"
                  getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  dropdownStyle={{ zIndex: 99999 }}
                  dropdownClassName="issue-category-dropdown"
                  style={{ width: '100%' }}
                  size="large"
                >
                  {categories.map((cat) => (
                    <Option key={cat.issueCategoryId} value={cat.issueCategoryId}>
                      {cat.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
          </div>

          {showExtraFields && (
            <div className="row g-3">
              <div className="col-md-6">
                <Form.Item label={<span className="fw-bold text-secondary" style={{ fontSize: '14px' }}>Priority *</span>}>
                  <Select
                    placeholder="Select priority"
                    value={this.state.priority}
                    onChange={(val) => {
                      const selectedPriority = this.state.priorities.find(p => p.issuePriorityId === val);
                      let newEndDate = null;
                      if (selectedPriority && selectedPriority.days) {
                        const moment = window.moment || require('moment');
                        newEndDate = moment().add(selectedPriority.days, 'days');
                      }
                      this.setState({ priority: val, estimatedEndDate: newEndDate });
                    }}
                    style={{ width: '100%' }}
                    size="large"
                    loading={this.state.loadingPriorities}
                    showSearch
                    optionFilterProp="children"
                  >
                    {this.state.priorities.map(p => <Option key={p.issuePriorityId} value={p.issuePriorityId}>{p.name}</Option>)}
                  </Select>
                </Form.Item>
              </div>
              <div className="col-md-6">
                <Form.Item label={<span className="fw-bold text-secondary" style={{ fontSize: '14px' }}>Estimated End Date</span>}>
                  <DatePicker
                    placeholder="Auto-calculated"
                    value={estimatedEndDate}
                    disabled
                    style={{ width: '100%', height: '40px', borderRadius: '6px', backgroundColor: '#f5f5f5', color: '#888' }}
                  />
                </Form.Item>
              </div>
            </div>
          )}

          {showExtraFields && (
            <div className="row g-3">
              <div className="col-md-6">
                <Form.Item label={<span className="fw-bold text-secondary" style={{ fontSize: '14px' }}>Raised By *</span>}>
                  <Select
                    placeholder="Select name"
                    value={raisedBy}
                    onChange={(val) => this.setState({ raisedBy: val })}
                    style={{ width: '100%' }}
                    size="large"
                    loading={this.state.loadingUsers}
                    showSearch
                    optionFilterProp="children"
                  >
                    {users.map(u => <Option key={u.profile_id} value={u.profile_id}>{u.name}</Option>)}
                  </Select>
                </Form.Item>
              </div>
              <div className="col-md-6">
                <Form.Item label={<span className="fw-bold text-secondary" style={{ fontSize: '14px' }}>Sub - Location (room / lab / block)</span>}>
                  <Input
                    placeholder="e.g. Computer lab 2 , Block B Room 14"
                    value={sublocation}
                    onChange={(e) => this.setState({ sublocation: e.target.value })}
                    style={{ height: '42px', borderRadius: '6px' }}
                  />
                </Form.Item>
              </div>
            </div>
          )}

          {showExtraFields && (
            <div className="row g-3">
              <div className="col-md-6">
                <Form.Item label={<span className="fw-bold text-secondary" style={{ fontSize: '14px' }}>Assign To *</span>}>
                  <Select
                    placeholder="Select name"
                    value={assignTo}
                    onChange={(val) => this.setState({ assignTo: val })}
                    style={{ width: '100%' }}
                    size="large"
                    loading={this.state.loadingUsers}
                    showSearch
                    optionFilterProp="children"
                  >
                    {users.map(u => <Option key={u.profile_id} value={u.profile_id}>{u.name}</Option>)}
                  </Select>
                </Form.Item>
              </div>
              <div className="col-md-6"></div>
            </div>
          )}

          {!showExtraFields && (
            <Form.Item label={<span className="fw-bold text-secondary" style={{ fontSize: '14px' }}>Sub - Location (room / lab / block)</span>}>
              <Input
                placeholder="e.g. Computer lab 2 , Block B Room 14"
                value={sublocation}
                onChange={(e) => this.setState({ sublocation: e.target.value })}
                style={{ height: '42px', borderRadius: '6px' }}
              />
            </Form.Item>
          )}

          <Form.Item label={<span className="fw-bold text-secondary" style={{ fontSize: '14px' }}>Description</span>}>
            <TextArea
              rows={5}
              placeholder="e.g. What's wrong and how is it affecting classes or safety?"
              value={description}
              onChange={(e) => this.setState({ description: e.target.value })}
              style={{ borderRadius: '6px' }}
            />
          </Form.Item>

          <Form.Item label={<span className="fw-bold text-secondary" style={{ fontSize: '14px' }}>Photos / File Attachment</span>}>
            <Upload
              listType="picture"
              fileList={fileList}
              customRequest={this.handleCustomRequest}
              onRemove={this.handleRemove}
              onChange={this.handleUploadChange}
              maxCount={5}
              className="w-100"
            >
              {fileList.length < 5 && (
                <Button className="w-100 d-flex align-items-center justify-content-center" style={{ borderStyle: 'dashed', height: '46px', borderRadius: '8px' }}>
                  <span className="fw-bold text-dark" style={{ fontSize: '14px' }}>+ Add photo / file ({fileList.length}/5)</span>
                </Button>
              )}
            </Upload>
            <div className="mt-2 text-muted" style={{ fontSize: '13px' }}>
              Up to 5 files, 10MB each. Camera or gallery on mobile.
            </div>
          </Form.Item>

          <div className="d-flex justify-content-end mt-4 gap-3 pt-2">
            <Button
              onClick={onCancel}
              disabled={submitting}
              style={{
                backgroundColor: '#f1f1f1',
                border: 'none',
                fontWeight: 'bold',
                padding: '0 32px',
                height: '42px',
                borderRadius: '6px',
                fontSize: '14px',
              }}
            >
              Close
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              loading={submitting}
              style={{
                backgroundColor: '#fca000',
                borderColor: '#fca000',
                color: '#fff',
                fontWeight: 'bold',
                padding: '0 32px',
                height: '42px',
                borderRadius: '6px',
                fontSize: '14px',
              }}
            >
              {isOperation ? "Submit" : "Submit To Operations"}
            </Button>
          </div>
        </Form>
      </Modal>
    );
  }
}

export default connect(AddNewIssueModal);
